import IntroA from "../components/walkthrough/IntroA";
import IntroB from "../components/walkthrough/IntroB";
import IntroC from "../components/walkthrough/IntroC";
import IntroD from "../components/walkthrough/IntroD";
import OutroA from "../components/walkthrough/OutroA";
import OutroB from "../components/walkthrough/OutroB";
import ImageOnScreen from "../components/walkthrough/ImageOnScreen";
import ImageCenter from "../components/walkthrough/ImageCenter";
import InfoPopup from "../components/walkthrough/InfoPopup";
import BackgroundOnly from "../components/walkthrough/BackgroundOnly";
import Alert from "../components/walkthrough/Alert";

// Registry: map string keys used in JSON to React components
// Keep this small and explicit so bundlers and linters can resolve imports.
const registry = {
  IntroA,
  IntroB,
  IntroC,
  IntroD,
  OutroA,
  OutroB,
  ImageOnScreen,
  ImageCenter,
  InfoPopup,
  BackgroundOnly,
  Alert
};

export default registry;
